import React, { useEffect, useState } from 'react';
import { Loader2, Send } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { errMsg } from '@/services/staffAttendanceApi';
import { ptApi, splitEmails } from '@/services/ptFilesApi';

/** Email one invoice's PT file: To from Customer Master (or typed when it has none), CC from the saved list. */
export const PtEmailDialog = ({ row, gmail, onClose, onSent }) => {
  const [to, setTo] = useState('');
  const [cc, setCc] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (row) { setTo((row.emails || []).join(', ')); setCc((gmail?.settings?.cc || []).join(', ')); }
  }, [row?.invoice_no]); // eslint-disable-line react-hooks/exhaustive-deps
  const send = async () => {
    setBusy(true);
    try {
      const r = await ptApi.email(row.invoice_no, splitEmails(to), splitEmails(cc));
      toast.success(`PT file for ${row.invoice_no} emailed`, { description: `To ${r.to.join(', ')}${r.cc.length ? ` · CC ${r.cc.join(', ')}` : ''}` });
      onSent();
      onClose();
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(d?.message || errMsg(e, 'Could not send the email'), { description: (d?.problems || []).join(' · '), duration: 10000 });
    } finally { setBusy(false); }
  };
  const noMaster = row && !(row.emails || []).length;
  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="pt-email-dialog">
        <DialogHeader>
          <DialogTitle>Email PT file · {row?.invoice_no}</DialogTitle>
          <DialogDescription>{row?.customer} · sent from {gmail?.email}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1">
            <Label className="text-xs">To</Label>
            <Input value={to} onChange={(e) => setTo(e.target.value)} placeholder="distributor@example.com" data-testid="pt-email-to" />
            {noMaster && <p className="text-xs text-amber-700" data-testid="pt-email-no-master">No email in Customer Master — type one for this send</p>}
          </div>
          <div className="space-y-1">
            <Label className="text-xs">CC (comma separated)</Label>
            <Input value={cc} onChange={(e) => setCc(e.target.value)} placeholder="none" data-testid="pt-email-cc" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="pt-email-cancel">Cancel</Button>
          <Button onClick={send} disabled={busy || !splitEmails(to).length} className="bg-[#2D5F4F] hover:bg-[#244c3f]" data-testid="pt-email-send">
            {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Send className="w-4 h-4 mr-1" />}Send</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
